"use strict";
/**
 * @module adaptive-expressions
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const expressionProperties_1 = require("../expressionProperties");
class ObjectExpressionConverter {
    convert(value) {
        return new expressionProperties_1.ObjectExpression(value);
    }
}
exports.ObjectExpressionConverter = ObjectExpressionConverter;
//# sourceMappingURL=objectExpressionConverter.js.map